import { render, staticRenderFns } from "./InventoryStockList.vue?vue&type=template&id=25dabd3c&"
import script from "./InventoryStockList.vue?vue&type=script&lang=js&"
export * from "./InventoryStockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports